import { MAX_EVENTS } from '../core/constants';

export const EventKind = {
  CollisionDetected: 0,
  EntityDied: 1,
  EntitySpawned: 2,
  EntityDespawned: 3,
  LevelEnded: 4,
} as const;
export type EventKindId = (typeof EventKind)[keyof typeof EventKind];

export class EventQueue {
  readonly kind = new Uint8Array(MAX_EVENTS);
  readonly source = new Int16Array(MAX_EVENTS);
  readonly target = new Int16Array(MAX_EVENTS);
  readonly sourceRecordingEntityId = new Uint32Array(MAX_EVENTS);
  readonly targetRecordingEntityId = new Uint32Array(MAX_EVENTS);
  readonly definition = new Uint8Array(MAX_EVENTS);
  readonly x = new Float32Array(MAX_EVENTS);
  readonly y = new Float32Array(MAX_EVENTS);
  readonly value = new Float32Array(MAX_EVENTS);
  count = 0;

  push(kind: EventKindId, source = -1, target = -1, definition = 0, x = 0, y = 0, value = 0, sourceRecordingEntityId = 0, targetRecordingEntityId = 0): void {
    if (this.count >= MAX_EVENTS) throw new Error('EventQueue capacity exceeded');
    const index = this.count++;
    this.kind[index] = kind;
    this.source[index] = source;
    this.target[index] = target;
    this.sourceRecordingEntityId[index] = sourceRecordingEntityId;
    this.targetRecordingEntityId[index] = targetRecordingEntityId;
    this.definition[index] = definition;
    this.x[index] = x;
    this.y[index] = y;
    this.value[index] = value;
  }

  clear(): void { this.count = 0; }
}
